<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="size"
    :height="size"
    viewBox="0 0 18 20"
    class="svg-icon"
  >
    <g :fill="color" fill-rule="nonzero">
      <path
        d="M3.167.833h4.166c.46 0 .834.373.834.834 0 .425-.318.775-.73.827l-.104.006H3.167c-.425 0-.776.318-.827.729l-.007.104v13.334c0 .425.318.775.73.827l.104.006h4.166c.46 0 .834.373.834.833 0 .425-.318.776-.73.827l-.104.007H3.167c-1.326 0-2.41-1.032-2.495-2.336l-.005-.164V3.333C.667 2.008 1.698.923 3.002.84l.165-.006h4.166zm10.504 5.17l.085.074 3.333 3.334.016.016.039.044-.055-.06c.032.032.06.065.086.1.013.018.026.037.037.056l.016.026c.067.12.105.26.105.407 0 .109-.02.212-.058.307l-.016.037-.029.058c-.007.014-.016.028-.024.041l-.03.045-.012.016-.016.02c-.015.019-.031.037-.048.054l-.01.011-3.334 3.334c-.326.325-.853.325-1.179 0-.298-.299-.323-.767-.074-1.094l.074-.085 1.91-1.91H6.5c-.425 0-.775-.319-.827-.73L5.667 10c0-.46.373-.833.833-.833h7.988l-1.91-1.911c-.326-.326-.326-.853 0-1.179.298-.298.766-.323 1.093-.074z"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-exit",
  components: {},
})
export class IconExit extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;

  constructor() {
    super();
  }
}
export default IconExit;
</script>
